var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tsRoot"},[(_vm.$store.state.banner)?_c('divBanner',{ref:"tsHeader"}):_vm._e(),(_vm.$store.state.headers)?_c('divHeader',{ref:"tsHeader"}):_vm._e(),(_vm.$store.state.login)?_c('divLogin',{ref:"tsLogin"}):_vm._e(),_c('nuxt',{ref:"tsNuxt"}),(_vm.$store.state.footers)?_c('divFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }